module.exports = __webpack_public_path__ + "img/favicon.12f5fe61.ico";